import { NavLink } from '@/components/ui';
import styles from './MarketplaceBreadcumb.module.css';
import { useGlobalContext } from '@/lib/context';
import { SchemaHead } from '@/components/shared/schemaHead';
type props = {
    breadCrumbJson: {
        name: string,
        url: string
    }[]
    customCss?: Object
}
export function MarketplaceBreadcrumb({ breadCrumbJson, customCss }: props) {
    const { props: { isMobileView, isAppView } } = useGlobalContext();
    const baseUrl = process.env.SITE_URL;
    const bredCrumb = [
        {
            name: 'Home',
            url: `${baseUrl}`
        },
        {
            name: 'Online Store',
            url: `${baseUrl}/online-store`
        },
        ...breadCrumbJson
    ]
    const schemaData = () => {
        const itemListElement: string[] = [];
        bredCrumb.forEach((d, idx) => {
            if (bredCrumb.length - 1 == idx)
                itemListElement.push(`{
                    "@type": "ListItem",
                    "position": ${idx + 1},
                    "name": "${d.name}"
                }`);
            else
                itemListElement.push(`{
                    "@type": "ListItem",
                    "position": ${idx + 1},
                    "name": "${d.name}",
                    "item": "${d.url}"
                }`);
        })

        const _schema = {
            __html: `
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [${itemListElement}]
            }`
        }
        return _schema;
    };
    if(isAppView) return <></>;
    return (
        <>
            <SchemaHead data={schemaData()} navSchemaData={[]} />
            <div className={styles.topSectionBox} style={isMobileView ? customCss : {}}>
                <div className={`${styles.containerFull} containerFull`}>
                    <div className={`${styles.mkPlaceBreadcrum}`}>
                        <ul>
                            {
                                bredCrumb && bredCrumb.map((f, idx) =>
                                    <li key={idx} title={f.name}>
                                        {
                                            f.url != '' ? <NavLink href={f.url}>{f.name}</NavLink> : f.name
                                        }
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}